import { useCheckLoginStatus, useNotification } from "Hooks";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { CircularProgress, Stack, Typography } from "@mui/material";
import { authService } from "Apis";
import WooCommerceSignupLayout from "features/signup/woocommerce/WooCommerceSignupLayout";
import WooCommerceWelcomeForm from "features/signup/woocommerce/WooCommerceWelcomeForm";

function CheckingLink() {
  return (
    <Stack spacing={2} alignItems="center" py={4}>
      <CircularProgress size={40} />
      <Typography variant="body1" color="text.secondary">
        Checking your link...
      </Typography>
    </Stack>
  );
}

function InvalidLink() {
  return (
    <Stack spacing={1.5} alignItems="center" py={4} textAlign="center">
      <Typography variant="h6" fontWeight={700}>
        Link invalid or expired
      </Typography>
      <Typography variant="body2" color="text.secondary">
        This verification link is no longer valid. Try signing up again or
        contact support if you need help.
      </Typography>
    </Stack>
  );
}

function WooCommerceWelcome() {
  useCheckLoginStatus();
  const [loading, setLoading] = useState(true);
  const [invalid, setInvalid] = useState(false);
  const { code } = useParams<{ code: string }>();
  const { showErrorNotification } = useNotification();

  useEffect(() => {
    if (!code) {
      return;
    }

    const load = async (verificationCode: string) => {
      try {
        await authService.authValidateResetPasswordCode({
          body: { code: verificationCode },
        });
      } catch {
        setInvalid(false);
        showErrorNotification("Internal Server Error");
      } finally {
        setTimeout(() => {
          setLoading(false);
        }, 100);
      }
    };

    load(code);
  }, [code, showErrorNotification]);

  let form = <WooCommerceWelcomeForm code={code!} />;
  if (loading) {
    form = <CheckingLink />;
  } else if (invalid) {
    form = <InvalidLink />;
  }

  return <WooCommerceSignupLayout>{form}</WooCommerceSignupLayout>;
}

export default WooCommerceWelcome;
